import angular from 'angular';

/**
 * @memberOf cms.input.select
 * @property {object}      bindings.errors     Form errors object
 * @property {object|text} bindings.model      Input value reference
 * @property {string}      bindings.title      Input title and/or placeholder
 * @property {array}       bindings.options    Select options
 * @property {boolean}     bindings.multiple   Multi or single select
 *
 * @todo More flexible data operations in ui-select-choices
 */
let cmsFontSelect = {
    bindings: {
        errors: '<',
        model: '=',
        label: '@',
        helper: '@',
        options: '<',
        multiple: '<',
        aclShow: '<?',
        aclDisable: '<?',
        labelSize: '@',
        inputSize: '@'
    },
    template: require('./fontSelect.html'),
    controller: function () {
        this.$onInit = () => {
            this.options =  ["Abril FatFace", "Archivo", "Arvo", "Cardo", "Cormorant", "Fira Sans",
                "Fjalla One", "Frank Ruhl Libre", "Karla", "Lato", "Lora", "Merriweather", "Montserrat", "Noto Sans",
                "Nunito", "Old Standard TT", "Open Sans", "Oswald", "Oxygen", "PT Sans", "PT Serif", "Playfair Display",
                "Poppins", "Rakkas", "Roboto", "Rubik", "Source Sans", "Source Sans Pro", "Spectral", "Ubuntu", "Work Sans", "Yatra One"];
        };


    }
};

/**
 * Select control using ui-select
 * @namespace cms.input.select
 * @see https://angular-ui.github.io/ui-select
 */
export default angular.module('cms.input.font.select', []).component('cmsInputFontSelect', cmsFontSelect).name;



// WEBPACK FOOTER //
// ./src/cmsCore/Controls/FontSelectControl/CmsFontSelect.js